import React, { useState } from "react";
import "./ViewBlock.scss";
import {
  ArrowRight,
  Block,
  CalenderIcon2,
  Edit,
  FullScreen,
  LinkIcon,
  Playback,
  Rating,
  Share,
  Trash,
  Trash2,
} from "../../ui/icons";
import {
  Button,
  ButtonWithIcon,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  SelectButton,
  Textbox,
} from "../../ui";
import { B1, H2, H3, L } from "../../ui/Typography";

/* images */
import block1 from "../../assets/images/live-image.png";
/* end images */

function ViewBlock() {
  /*start Streaming liv or play back */
  const [streaming, setStreaming] = useState("true");
  /*end Streaming liv or play back */
  /*start model open code */
  const [editBlock, setEditBlock] = useState(false);
  const handleCloseEditBlockModel = () => setEditBlock(false);

  const [deleteBlock, setDeleteBlock] = useState(false);
  const handleCloseDeleteBlockModel = () => setDeleteBlock(false);

  /*end model open code */

  return (
    <div className="block-view-wrapper">
      <div className="block-view-container">
        <div className="borderWrapper w-100 h-100">
          <div className="borderInner h-100">
            <div className="block-view-inner">
              <div className="block-view-heading">
                <span className="breadcrumb">
                  <Block size="md" className="block-icon" />
                  PNTC Veranda
                  <ArrowRight size="md" />
                  Headquaters 01
                </span>
                <div className="block-view-buttons">
                  <SelectButton
                    options={[
                      { label: "Live", value: "true" },
                      { label: "Playback", value: "false" },
                    ]}
                    name="Camera_Stream"
                    size="md"
                    value={streaming}
                    onChange={setStreaming}
                  />
                  <ButtonWithIcon icon={Share} size="md" />
                  <ButtonWithIcon
                    icon={Trash}
                    size="md"
                    onClick={() => setDeleteBlock(true)}
                  />
                  <ButtonWithIcon
                    icon={Edit}
                    size="md"
                    onClick={() => setEditBlock(true)}
                  />
                </div>
              </div>
              <div className="block-view-details">
                <div className="block-view-left">
                  <div className="block-view-video-box">
                    <img src={block1} className="block-view-video" />
                    <div className="block-video-controller">
                      <div className="top-block-video-controller">
                        <div className="left-top-block-video-controller">
                          <span>
                            <Playback size="sm" /> Live
                          </span>
                        </div>
                        <div className="right-top-block-video-controller">
                          <span>
                            <LinkIcon size="sm" />{" "}
                            //seedvms.io/stream/8f1a3b2c9e7
                          </span>
                          <ButtonWithIcon size="lg" icon={FullScreen} />
                        </div>
                      </div>
                      <div className="bottom-block-video-controller">
                        Video controller
                      </div>
                    </div>
                  </div>
                </div>
                <div className="block-view-right">
                  <div className="block-view-camera-details">
                    <div className="borderWrapper w-100">
                      <div className="borderInner">
                        <div className="block-view-camera-details-inner">
                          {streaming === "true" && (
                            <div className="timer-live-camera">
                              <div className="borderWrapper w-100">
                                <div className="borderInner">
                                  <div className="timer-live-camera-inner">
                                    <H2 className="timer">04:20:16</H2>
                                    <H3 className="day">Tuesday</H3>
                                    <H3 className="date">20/05/2025</H3>
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}
                          {streaming === "false" && (
                            <div className="playback-camera">
                              <div className="form-group-box">
                                <L
                                  forInput="select_date"
                                  className="label"
                                  size="md"
                                >
                                  Select Date
                                </L>
                                <Textbox
                                  type="date"
                                  size="md"
                                  widthSize="sm"
                                  className="playback-input"
                                  id="select_date"
                                  placeholder="--/--/----"
                                  icon={CalenderIcon2}
                                  iconSide="right"
                                />
                              </div>
                              <div className="form-group-box grid-parent">
                                <div className="form-group-col grid-md-6">
                                  <L
                                    forInput="hours"
                                    className="label"
                                    size="md"
                                  >
                                    Hours
                                  </L>
                                  <Textbox
                                    placeholder="--:--"
                                    size="md"
                                    widthSize="sm"
                                    id="hours"
                                    className="playback-input"
                                  />
                                </div>
                                <div className="form-group-col grid-md-6">
                                  <L
                                    forInput="mins"
                                    className="label"
                                    size="md"
                                  >
                                    Minutes
                                  </L>
                                  <Textbox
                                    placeholder="--:--"
                                    size="md"
                                    widthSize="sm"
                                    id="mins"
                                    className="playback-input"
                                  />
                                </div>
                              </div>
                              <div className="playback-with-thumbnail grid-parent shadow-bottom-absolute shadow-up-absolute">
                                <div className="grid-md-6 ">
                                  <div className="timestamp-wrapper">
                                    <div className="timestamp-box">
                                      <img src={block1} className="timestamp" />
                                      <div className="time">
                                        <B1>03:00</B1>
                                      </div>
                                    </div>
                                    <div className="timestamp-box">
                                      <img src={block1} className="timestamp" />
                                      <div className="time">
                                        <B1>04:00</B1>
                                      </div>
                                    </div>
                                    <div className="timestamp-box">
                                      <img src={block1} className="timestamp" />
                                      <div className="time">
                                        <B1>05:00</B1>
                                      </div>
                                    </div>
                                    <div className="timestamp-box">
                                      <img src={block1} className="timestamp" />
                                      <div className="time">
                                        <B1>06:00</B1>
                                      </div>
                                    </div>
                                    <div className="timestamp-box">
                                      <img src={block1} className="timestamp" />
                                      <div className="time">
                                        <B1>07:00</B1>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="grid-md-6">
                                  <div className="timestamp-wrapper">
                                    <div className="timestamp-box">
                                      <img src={block1} className="timestamp" />
                                      <div className="time">
                                        <B1>00:02</B1>
                                      </div>
                                    </div>
                                    <div className="timestamp-box">
                                      <img src={block1} className="timestamp" />
                                      <div className="time">
                                        <B1>00:03</B1>
                                      </div>
                                    </div>
                                    <div className="timestamp-box">
                                      <img src={block1} className="timestamp" />
                                      <div className="time">
                                        <B1>00:04</B1>
                                      </div>
                                    </div>
                                    <div className="timestamp-box">
                                      <img src={block1} className="timestamp" />
                                      <div className="time">
                                        <B1>00:05</B1>
                                      </div>
                                    </div>
                                    <div className="timestamp-box">
                                      <img src={block1} className="timestamp" />
                                      <div className="time">
                                        <B1>00:06</B1>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="block-view-camera-states">
                    <div className="camera-states">
                      <L className="label">Status</L>
                      <span>Enabled</span>
                    </div>
                    <div className="camera-states">
                      <L className="label">Access</L>
                      <span>Enabled</span>
                    </div>
                    <div className="camera-states">
                      <L className="label">Health</L>
                      <Rating rating="3.5" size="md" className="ratting-icon" />
                    </div>
                    <div className="camera-states">
                      <L className="label">Location</L>
                      <B1>India</B1>
                    </div>
                    <div className="camera-states">
                      <L className="label">Added on</L>
                      <B1>12/12/2024</B1>
                    </div>
                    <div className="camera-states">
                      <L className="label">Added by</L>
                      <B1>Joseph Jobs</B1>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Modal show={editBlock} onHide={handleCloseEditBlockModel} size="md">
        <ModalHeader>Edit Headquaters 01</ModalHeader>
        <ModalBody>
          <div className="body-content">
            <div className="form-group-box">
              <L forInput="location" size="md">
                Block Name (camera)
              </L>
              <Textbox
                size="lg"
                name="Camera_Name"
                value="Headquaters 01"
                className="form-input"
              />
            </div>
            <div className="form-group-box">
              <L forInput="location" size="md">
                Block Name (camera)
              </L>
              <Textbox
                size="lg"
                name="Camera_Name"
                value="//seedvms.io/stream/8f1a3b2c9e7/stream/"
                className="form-input"
              />
            </div>
            <div className="form-group-box">
              <L forInput="location" size="md">
                Connection Mode
              </L>
              <SelectButton
                options={[
                  { label: "Shared", value: "Shared" },
                  { label: "Only Me", value: "Only Me" },
                ]}
                name="Camera_Stream"
                size="sm"
                value="Shared"
                /*    onChange={setConnectionMode} */
              />
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <div className="model-button-box">
            <Button className="model-button" size="lg">
              Discard
            </Button>
            <Button className="model-button" size="lg">
              Save changes
            </Button>
          </div>
        </ModalFooter>
      </Modal>
      <Modal show={deleteBlock} onHide={handleCloseDeleteBlockModel} size="sm">
        <ModalHeader></ModalHeader>
        <ModalBody>
          <div className="body-content">
            <div className="small-model-body-inner">
              <Trash2 className="loading-icon" />
              <B1 className="loading-message">
                Are you sure you
                <br />
                want to Delete ?
              </B1>
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <div className="model-button-box">
            <Button
              className="model-button"
              size="lg"
              onClick={() => setDeleteBlock(false)}
            >
              Cancel
            </Button>
            <Button className="model-button" size="lg">
              Delete anyway
            </Button>
          </div>
        </ModalFooter>
      </Modal>
    </div>
  );
}

export default ViewBlock;
